import { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, { InputNumberField, TextareaField } from '../../../../utils/InputField';
import { ApiUpdateInvoiceInfo } from '../InvoiceConfigOperation';

function UpdateInformationModal({ data, closeModal, handleReload }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Organization: data?.organization,
        Email: data?.email,
        PhoneNumber: data?.phoneNumber,
        Address: data?.address,
        Signatory1: data?.signatory1,
        Signatory2: data?.signatory2,
        Validity: data?.validity || 0
    });
    const { setMessage } = useTemplate();

    // const { handleReload } = useInvoiceInfo();

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        const payload = {
            Organization: formData?.Organization,
            Email: formData?.Email,
            PhoneNumber: formData?.PhoneNumber,
            Address: formData?.Address,
            Signatory1: formData?.Signatory1,
            Signatory2: formData?.Signatory2,
            Validity: Number(formData?.Validity)
        };
        setLoading(true);
        ApiUpdateInvoiceInfo(payload, setIsError)
            .then(({ title }) => {
                closeModal();
                handleReload();
                setMessage({ type: 'success', text: title });
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <InputField
                    label="Organization"
                    name="Organization"
                    placeholder="Type Organization..."
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <div className="flex gap-4">
                    <InputField
                        label="Phone Number"
                        name="PhoneNumber"
                        formData={formData}
                        onChange={handleChange}
                        required
                    />
                    <InputField
                        label="Email"
                        name="Email"
                        formData={formData}
                        onChange={handleChange}
                        required
                    />
                </div>

                <TextareaField
                    label="Address"
                    name="Address"
                    placeholder="Type Address..."
                    formData={formData}
                    onChange={handleChange}
                    className="h-28"
                    required
                />

                {/* <TextareaField
                    label="Signatory 1"
                    name="Signatory1"
                    formData={formData}
                    onChange={handleChange}
                    className="h-36"
                    required
                />
                <TextareaField
                    label="Signatory 2"
                    name="Signatory2"
                    formData={formData}
                    onChange={handleChange}
                    className="h-36"
                    required
                /> */}

                <InputNumberField
                    label="Validity"
                    name="Validity"
                    placeholder="Type Validity in days..."
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Update" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default UpdateInformationModal;
